import {createAction, props} from "@ngrx/store"
import {DropdownOption} from "../../../../models/dropdown-option.model";
import {DropDownModel, Report} from "../model/reports.model";

const CLEAR_STATE = '[reports] clear state'
export const ClearState = createAction(CLEAR_STATE)

const FETCH_REPORTS_OPTIONS_REQUEST = '[reports] fetch reports options request'
export const FetchReportsOptionsRequest = createAction(FETCH_REPORTS_OPTIONS_REQUEST,)

const FETCH_REPORTS_OPTIONS_SUCCESS = '[reports] fetch reports options success'
export const FetchReportsOptionsSuccess = createAction(FETCH_REPORTS_OPTIONS_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>())

const FETCH_REPORTS_OPTIONS_FAILURE = '[reports] fetch reports options failure'
export const FetchReportsOptionsFailure = createAction(FETCH_REPORTS_OPTIONS_FAILURE)

//clinics list action
const FETCH_CLINICS_OPTIONS_LIST_REQUEST = '[reports] fetch clinics options list request'
export const FetchClinicsOptionsListRequest = createAction(FETCH_CLINICS_OPTIONS_LIST_REQUEST,props<{payload:{ pageNumber: number, shouldInclude?: any,search?:string }}>())

const FETCH_CLINICS_OPTIONS_LIST_SUCCESS = '[reports] fetch clinics options list success'
export const FetchClinicsOptionsListSuccess = createAction(FETCH_CLINICS_OPTIONS_LIST_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>())

const FETCH_CLINICS_OPTIONS_LIST_FAILURE = '[reports] fetch clinics options list failure'
export const FetchClinicsOptionsListFailure = createAction(FETCH_CLINICS_OPTIONS_LIST_FAILURE)

//fetch group list
const FETCH_GROUPS_OPTIONS_LIST_REQUEST = '[reports] fetch groups options list request'
export const FetchGroupsOptionsListRequest = createAction(FETCH_GROUPS_OPTIONS_LIST_REQUEST,props<{payload:{ pageNumber: number, shouldInclude?: any,search?:string, clientId: any }}>())

const FETCH_GROUPS_OPTIONS_LIST_SUCCESS = '[reports] fetch groups options list success'
export const FetchGroupsOptionsListSuccess = createAction(FETCH_GROUPS_OPTIONS_LIST_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>())

const FETCH_GROUPS_OPTIONS_LIST_FAILURE = '[reports] fetch groups options list failure'
export const FetchGroupsOptionsListFailure = createAction(FETCH_GROUPS_OPTIONS_LIST_FAILURE)

//fetch behavior list
const FETCH_bBEHAVIOR_TYPE_OPTIONS_LIST_REQUEST = '[reports] fetch behavior type options list request'
export const FetchBehaviorTypeOptionsListRequest = createAction(FETCH_bBEHAVIOR_TYPE_OPTIONS_LIST_REQUEST)

const FETCH_BEHAVIOR_TYPE_OPTIONS_LIST_SUCCESS = '[reports] fetch behavior type options list success'
export const FetchBehaviorTypeOptionsListSuccess = createAction(FETCH_BEHAVIOR_TYPE_OPTIONS_LIST_SUCCESS, props<{
  payload: { list: DropdownOption[] }
}>())

const FETCH_BEHAVIOR_TYPE_OPTIONS_LIST_FAILURE = '[reports] fetch behavior type options list failure'
export const FetchBehaviorTypeOptionsListFailure = createAction(FETCH_BEHAVIOR_TYPE_OPTIONS_LIST_FAILURE)


//fetch participant list
const FETCH_PARTICIPANT_OPTIONS_LIST_REQUEST = '[reports] fetch participant options list request'
export const FetchParticipantOptionsListRequest = createAction(FETCH_PARTICIPANT_OPTIONS_LIST_REQUEST,props<{payload:{ pageNumber: number, shouldInclude?: any,username?:string, groupId: any }}>())

const FETCH_PARTICIPANT_OPTIONS_LIST_SUCCESS = '[reports] fetch participant options list success'
export const FetchParticipantOptionsListSuccess = createAction(FETCH_PARTICIPANT_OPTIONS_LIST_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_PARTICIPANT_OPTIONS_LIST_FAILURE = '[reports] fetch participant options list failure'
export const FetchParticipantOptionsListFailure = createAction(FETCH_PARTICIPANT_OPTIONS_LIST_FAILURE)


// Fetch questionnaires list
const FETCH_QUESTIONNAIRE_OPTIONS_LIST_REQUEST = '[reports] fetch questionnaires list request'
export const FetchQuestionnaireOptionsListRequest = createAction(FETCH_QUESTIONNAIRE_OPTIONS_LIST_REQUEST)

const FETCH_QUESTIONNAIRE_OPTIONS_LIST_SUCCESS = '[reports] fetch questionnaires list success'
export const FetchQuestionnaireOptionsListSuccess = createAction(FETCH_QUESTIONNAIRE_OPTIONS_LIST_SUCCESS, props<any>())

const FETCH_QUESTIONNAIRE_OPTIONS_LIST_FAILURE = '[reports] fetch questionnaires list failure'
export const FetchQuestionnaireOptionsListFailure = createAction(FETCH_QUESTIONNAIRE_OPTIONS_LIST_FAILURE)

// add reports to the store
// these are dummy actions as of now
const ADD_REPORTS = '[reports] add reports'
export const AddReports = createAction(ADD_REPORTS, props<{
  payload: {
    report: Report
  }
}>())

//generate new reports
const  GENERATE_NEW_REPORTS_REQUEST='[reports] generate new reports request';
export  const GenerateNewReportsRequest=createAction(GENERATE_NEW_REPORTS_REQUEST, props<{
  payload:{
    reportType:string,
    reportRequestPayload:any
  }
}>());

const  GENERATE_NEW_REPORTS_SUCCESS='[reports] generate new reports success';
export  const GenerateNewReportsSuccess=createAction(GENERATE_NEW_REPORTS_SUCCESS, props<{
  reportId?: number
}
>());

const  GENERATE_NEW_REPORTS_FAILURE='[reports] generate new reports failure';
export  const GenerateNewReportsFailure=createAction(GENERATE_NEW_REPORTS_FAILURE);

// fetch generated report list
const FETCH_GENERATED_REPORTS_LIST_REQUEST='[reports] fetch generated reports list request'
export const FetchGeneratedReportsListRequest=createAction(FETCH_GENERATED_REPORTS_LIST_REQUEST,props<{
  payload:{
    pageNumber:number,
    sortColumn?:string,
    sortOrder?:number
  }
}>());

const FETCH_GENERATED_REPORTS_LIST_SUCCESS='[reports] fetch generated reports list success'
export const FetchGeneratedReportsListSuccess=createAction(FETCH_GENERATED_REPORTS_LIST_SUCCESS,props<{
  payload:any
}>());

const FETCH_GENERATED_REPORTS_LIST_FAILURE='[reports] fetch generated reports list failure'
export const FetchGeneratedReportsListFailure=createAction(FETCH_GENERATED_REPORTS_LIST_FAILURE);

// download report

const DOWNLOAD_REPORTS_REQUEST='[reports] download reports request'
export const DownloadReportRequest = createAction(DOWNLOAD_REPORTS_REQUEST,props<{
  payload:{
    reportId:number
  }
}>())

const DOWNLOAD_REPORTS_SUCCESS='[reports] download reports success'
export const DownloadReportSuccess = createAction(DOWNLOAD_REPORTS_SUCCESS)

const DOWNLOAD_REPORTS_FAILURE='[reports] download reports failure'
export const DownloadReportFailure = createAction(DOWNLOAD_REPORTS_FAILURE)


//regenerate reports
const REGENERATE_REPORT_REQUEST='[reports] regenerate reports request'
export const RegenerateReportRequest = createAction(REGENERATE_REPORT_REQUEST,props<{
  payload:{
    reportId:number
  }
}>())

const REGENERATE_REPORT_SUCCESS='[reports] regenerate reports success'
export const RegenerateReportSuccess = createAction(REGENERATE_REPORT_SUCCESS)

const REGENERATE_REPORTS_FAILURE='[reports] regenerate reports failure'
export const RegenerateReportFailure = createAction(REGENERATE_REPORTS_FAILURE)

// Check report status
const CHECK_REPORT_STATUS_REQUEST='[reports] check report status request'
export const CheckReportStatusRequest = createAction(CHECK_REPORT_STATUS_REQUEST,props<{
  payload:{
    reportId:number
  }
}>())

const CHECK_REPORT_STATUS_SUCCESS='[reports] check report status success'
export const CheckReportStatusSuccess = createAction(CHECK_REPORT_STATUS_SUCCESS,props<{
  payload: any
}>())

const CHECK_REPORT_STATUS_FAILURE='[reports] check report status failure'
export const CheckReportStatusFailure = createAction(CHECK_REPORT_STATUS_FAILURE)

// Start polling for a report
const START_REPORT_POLLING='[reports] start report polling'
export const StartReportPolling = createAction(START_REPORT_POLLING,props<{
  reportId:number
}>())

// Stop polling for a report
const STOP_REPORT_POLLING='[reports] stop report polling'
export const StopReportPolling = createAction(STOP_REPORT_POLLING,props<{
  reportId:number
}>())

// Update report status during polling
const UPDATE_REPORT_STATUS='[reports] update report status'
export const UpdateReportStatus = createAction(UPDATE_REPORT_STATUS,props<{
  payload:{
    reportId:number,
    status: any,
    error?: string
  }
}>())